import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Container, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';

import * as ROUTES from '../../constants/routes';
import SignOutButton from '../SignOut'
import { AuthUserContext } from '../Session';

import './index.css';

const Navigation = () => (
    <div>
        <AuthUserContext.Consumer>
            {
                authUser => authUser ? <NavigationAuth /> : <NavigationNonAuth />
            }
        </AuthUserContext.Consumer>
    </div>
);

class NavigationAuth extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        return (
            <div className="menuCabecalho">
                <Container>
                    <Navbar color="light" light expand="md">
                        <NavbarBrand href={ROUTES.SIGN_IN}>eXpert Serviços</NavbarBrand>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <NavLink href={ROUTES.MEUS_DADOS}>Meus Dados</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href={ROUTES.MINHAS_SOLICITACOES}>Minhas Solicitações</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href={ROUTES.SOLICITAR}>Solicitar Serviço</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink>
                                        <SignOutButton />
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Navbar>
                </Container>
            </div>
        )
    }
}

class NavigationNonAuth extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        return (
            <div>
                <Navbar color="light" light expand="md">
                    <NavbarBrand href={ROUTES.SIGN_IN}>eXpert Serviços</NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>

                    </Collapse>
                </Navbar>
            </div>
        )
    }
}


export default Navigation;